import { render } from "./DocumentArchiveUpdate.vue?vue&type=template&id=03460a88&ts=true"
import script from "./DocumentArchiveUpdate.vue?vue&type=script&lang=ts"
export * from "./DocumentArchiveUpdate.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSkeleton from 'quasar/src/components/skeleton/QSkeleton.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSkeleton});
